import { i18n } from '../main'
import isEmpty from './isEmpty'

class LanguageUtil {
  static $t (key) {
    const languageKey = i18n.locale

    // Defaulting to 'global' message group if not provided
    const parts = key.split('.')
    const messageGroup = !isEmpty(parts[1]) ? parts[0] : 'global'
    const messageKey = !isEmpty(parts[1]) ? parts[1] : key

    return i18n.messages[languageKey][messageGroup][messageKey]
  }
}

export default LanguageUtil
